import "./Checkbox.css"

interface CheckboxProps {
  label: string
  checked: boolean
  showCheckbox?: boolean
  onChange: (checked: boolean) => void
}

export default function NutritionCheckbox({
  label,
  checked,
  showCheckbox = true,
  onChange
}: CheckboxProps) {
  return (
    <label htmlFor="nutrition-checkbox-container" className="checkbox-container bf-checkbox">
      {showCheckbox ? (
        <>
          <input
            type="checkbox"
            id="nutrition-checkbox-container"
            checked={checked}
            onChange={event => onChange(event.target.checked)}
            className="checkbox-input"
          />
          <span className="checkbox-custom"></span>
        </>
      ) : null}
      <span className="checkbox-label">{label}</span>
    </label>
  )
}
